// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 347 ? "SVG" : chunkId) + "." + {"181":"b552df83","347":"d50de807","389":"81fb9f89","939":"75ca8da4"}[chunkId] + ".chunk.js";
};